// extracted by mini-css-extract-plugin
module.exports = {"container":"_2FR-MOjscIQ7wXL7hrTI5s","anchor":"_3XvT-L4YilC4MRJD1nJD3h","label":"_1EvAlh_Q3ey0-3unRKfQxy","icon":"aLj4w9qb3dgn4nde78xsT"};